/*eslint-disable*/
import { TextField, withStyles } from '@material-ui/core';
import React from 'react';

const styles = theme => ({
	textField: {
		width: '100%',
		marginTop: 0,
		marginBottom: 0
	}
});

const chars = '0123456789/';

class FormInputClass extends React.Component {
	constructor(props) {
		super(props);
	}

	handleChange = (event, value) => {
		event.preventDefault();
		let length = event.target.value.length;

		if (length == 2 && value.length < 3) {
			event.target.value = event.target.value + '/';
		}

		if (length == 5 && value.length < 6) {
			event.target.value = event.target.value + '/';
		}

		if (this.props.input.onChange) {
			this.props.input.onChange(event);
			this.props.input.onBlur(event);
		}
	};

	shouldComponentUpdate(nextProps) {
		var comparedState = false;

		Object.keys(this.props).map(s => {
			if (this.props[s] !== nextProps[s]) {
				comparedState = true;
			}
			return s;
		});

		return comparedState;
	}

	render() {
		this.props.meta.valid = false;

		let trySubmit = this.props.checkValidation ? true : false;

		const {
			meta: { touched, error, warning }
		} = this.props;

		let lValue = this.props.fixedValue
			? this.props.fixedValue
			: this.props.input.value;

		return (
			<TextField
				onChange={e => this.handleChange(e, lValue)}
				id={this.props.input.name}
				value={lValue ? lValue : ''}
				label={this.props.label}
				className={this.props.classes.textField}
				margin="normal"
				error={
					error && error.length > 0 && (touched || this.props.fixedValue)
						? true
						: error && error.length > 0 && trySubmit
						? true
						: false
				}
				helperText={
					(error && (touched || this.props.fixedValue)) || (error && trySubmit)
						? error
						: null
				}
				InputProps={{
					readOnly: this.props.readOnly ? true : false
				}}
				placeholder={this.props.placeholder}
			/>
		);
	}
}

export default withStyles(styles)(FormInputClass);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/DayMonthYear.js